import React, { useContext, useMemo, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CustomPricingList from '../components/lists/CustomPricingList';
import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierPricingPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const content = !!selectedCarrier && (
    <>
      <StickyPageHeader
        actions={headerActions}
        subtitle={selectedCarrier.name}
        title="Custom Pricing"
      />
      <CustomPricingList
        carrier={selectedCarrier}
        onHeaderActions={setHeaderActions}
      />
    </>
  );

  if (disableLayout) {
    return content || null;
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierPricingPage;
